import { render, staticRenderFns } from "./CategoriaTramites.vue?vue&type=template&id=8ac512b0&scoped=true"
import script from "./CategoriaTramites.vue?vue&type=script&lang=ts"
export * from "./CategoriaTramites.vue?vue&type=script&lang=ts"
import style0 from "./CategoriaTramites.vue?vue&type=style&index=0&id=8ac512b0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8ac512b0",
  null
  
)

export default component.exports